'use client';

import { PageHeader } from '@/components/layout/page-header/page-header';

export const ReviewsPageHeader = () => {
  return (
    <div className="hidden md:block">
      <PageHeader title="Правила публикации отзывов" />
    </div>
  );
};
